import { persistReducer } from 'redux-persist';
import rootReducer from '../redux/reducers/index';
//import { storage } from './storage';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const persistConfig = {
  key: 'rapchik_root',
  version: 1,
  storage: storage,
  whitelist: ['signIn', 'getUser'], // specify which reducers you want to persist
};

export const persistedReducer = persistReducer(persistConfig, rootReducer);